{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "shop",
  "features": [
    {
      "id": "work-packages",
      "name": "Work Packages",
      "summary": "Scope, tasks, and status for every event.",
      "availability": "AVAILABLE"
    },
    {
      "id": "job-cards",
      "name": "Job Cards",
      "summary": "Structured task execution with steps, evidence, and signoff.",
      "availability": "AVAILABLE"
    },
    {
      "id": "findings",
      "name": "Findings & Non-Routines",
      "summary": "Capture discrepancies and route for authorization.",
      "availability": "AVAILABLE"
    },
    {
      "id": "customer-authorization",
      "name": "Customer Authorization",
      "summary": "Approvals for added scope.",
      "availability": "AVAILABLE"
    },
    {
      "id": "inspection-quality",
      "name": "Inspection & Quality",
      "summary": "Inspection and independent-check routing.",
      "availability": "AVAILABLE"
    },
    {
      "id": "shift",
      "name": "Shift",
      "summary": "Hand off open work between shifts.",
      "availability": "AVAILABLE"
    },
    {
      "id": "parts-readiness",
      "name": "Parts Readiness",
      "summary": "Parts and tooling status for active work.",
      "availability": "AVAILABLE"
    },
    {
      "id": "closeout",
      "name": "Documentation Closeout",
      "summary": "Find gaps before release.",
      "availability": "AVAILABLE"
    },
    {
      "id": "delivery-packages",
      "name": "Delivery Packages",
      "summary": "Return organized evidence to the customer.",
      "availability": "AVAILABLE"
    }
  ]
}